import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextareaAutosize } from "@material-ui/core"
import Grid from "@material-ui/core/Grid"
import List from "@material-ui/core/List"
import ListItem from "@material-ui/core/ListItem"
import ListItemIcon from "@material-ui/core/ListItemIcon"
import ListItemText from "@material-ui/core/ListItemText"
import Paper from "@material-ui/core/Paper"
import Typography from "@material-ui/core/Typography"
import DoneIcon from "@material-ui/icons/Done"
import ErrorIcon from "@material-ui/icons/Error"
import React from "react"
import { knowledgeAreaArray, userTypes } from "../../Constants"
import useStyles from "../../MUIClasses/useStyles"

const ThreeAsTwo = ({ asEvaluator, asAdmin, readOnly, paperURL, paperURL2, userType, paperFile, paperFile2, paperTitle, abstract, users, knowledgeArea, firstAuthor }) => {
    const presenterName = users.find(u => u.ucpf.toString() === firstAuthor.toString()).uName || ''

    const notOwner = Boolean(asEvaluator || asAdmin)

    return (
        <div >
            <Paper className={useStyles().paper}>
                <div>
                    <div style={{ marginBottom: 32 }}>
                        <Typography variant="h3">
                            {
                                readOnly ?
                                    "Leitura"
                                    :
                                    "Confirmação de Inscrição"
                            }
                        </Typography>
                    </div>
                    <div>
                        <List component="nav">
                            {
                                !notOwner &&
                                <>
                                    <Typography color="secondary">Tipo de Inscrição</Typography>
                                    <Grid container>
                                        <Grid item>
                                            <ListItem>
                                                <ListItemIcon>
                                                    {['1', '2', '3'].includes(userType) ? (
                                                        <DoneIcon />
                                                    ) :
                                                        <ErrorIcon />
                                                    }
                                                </ListItemIcon>
                                                <ListItemText>
                                                    {
                                                        userTypes.find(u => u.value === userType).title
                                                    }
                                                </ListItemText>
                                            </ListItem>
                                        </Grid>
                                    </Grid>
                                </>
                            }

                            <Typography color="secondary">Título do Trabalho</Typography>

                            <Grid container>
                                <Grid item>
                                    <ListItem>
                                        <ListItemIcon>
                                            {paperTitle ? (
                                                <DoneIcon />
                                            ) :
                                                <ErrorIcon />
                                            }
                                        </ListItemIcon>
                                        <ListItemText>
                                            {paperTitle}
                                        </ListItemText>
                                    </ListItem>
                                </Grid>
                            </Grid>

                            <Typography color="secondary">
                                Resumo do Trabalho
                            </Typography>

                            <Grid container>
                                <Grid item>
                                    <ListItem>
                                        <ListItemIcon>
                                            {abstract ? (
                                                <DoneIcon />
                                            ) :
                                                <ErrorIcon />
                                            }
                                        </ListItemIcon>
                                        <ListItemText>
                                            <TextareaAutosize
                                                maxRows={12}
                                                disabled={true}
                                                value={abstract}
                                            >
                                                {abstract}
                                            </TextareaAutosize>
                                        </ListItemText>
                                    </ListItem>
                                </Grid>
                            </Grid>

                            <Typography color="secondary">
                                Área do Conhecimento
                            </Typography>

                            <Grid container>
                                <Grid item>
                                    <ListItem>
                                        <ListItemIcon>
                                            {knowledgeAreaArray.filter(k => k.value === knowledgeArea).length ? (
                                                <DoneIcon />
                                            ) :
                                                <ErrorIcon />
                                            }
                                        </ListItemIcon>
                                        <ListItemText>
                                            {!knowledgeAreaArray.filter(k => k.value === knowledgeArea).length ? <p>Erro!</p> : knowledgeAreaArray.filter(k => k.value === knowledgeArea)[0].title}
                                        </ListItemText>
                                    </ListItem>
                                </Grid>
                            </Grid>

                            {!asEvaluator &&
                                <>
                                    <Typography color="secondary">Informações dos Autores</Typography>
                                    {
                                        !asEvaluator && !users.length ?
                                            <Grid container>
                                                <Grid item>
                                                    <ListItem>
                                                        <ListItemIcon>
                                                            <ErrorIcon />
                                                        </ListItemIcon>
                                                        <ListItemText>
                                                            <p>Email inválido</p>
                                                        </ListItemText>
                                                    </ListItem>
                                                </Grid>
                                            </Grid>
                                            :
                                            <TableContainer component={Paper}>
                                                <Table aria-label="users">
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell><b>Nome</b></TableCell>
                                                            <TableCell><b>E-mail</b></TableCell>
                                                            {
                                                                !readOnly && (
                                                                    <TableCell><b>CPF</b></TableCell>
                                                                )
                                                            }
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {users.map((row) => (
                                                            <TableRow key={row.ucpf}>
                                                                <TableCell>
                                                                    {row.uName}
                                                                </TableCell>
                                                                <TableCell>
                                                                    {row.uEmail}
                                                                </TableCell>
                                                                {
                                                                    !readOnly && (
                                                                        <TableCell>
                                                                            {row.ucpf}
                                                                        </TableCell>
                                                                    )
                                                                }
                                                            </TableRow>
                                                        ))}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>

                                    }
                                    <Typography color="secondary">
                                        Apresentador
                                    </Typography>
                                    <Grid container>
                                        <Grid item>
                                            <ListItem>
                                                <ListItemIcon>
                                                    {presenterName ? (
                                                        <DoneIcon />
                                                    ) :
                                                        <ErrorIcon />
                                                    }
                                                </ListItemIcon>
                                                <ListItemText>
                                                    {presenterName ? (
                                                        <p>{presenterName}</p>
                                                    ) :
                                                        (
                                                            <p>-</p>
                                                        )
                                                    }
                                                </ListItemText>
                                            </ListItem>
                                        </Grid>
                                    </Grid>
                                </>
                            }
                            <br />


                            <Typography color="secondary">
                                Arquivos do Resumo
                            </Typography>

                            {
                                readOnly ?
                                    asEvaluator ?
                                        // exibe apenas o paperURL2
                                        <Grid container>
                                            <Grid item>
                                                <ListItem>
                                                    <ListItemIcon>
                                                        {paperURL2 ? (
                                                            <DoneIcon />
                                                        ) :
                                                            <ErrorIcon />
                                                        }
                                                    </ListItemIcon>
                                                    <ListItemText>
                                                        {
                                                            paperURL2 ?
                                                                (
                                                                    <a href={paperURL2} target="_blank" rel="noopener noreferrer">Link para arquivo .pdf - ANONIMIZADO</a>
                                                                ) :
                                                                (
                                                                    <p>Arquivo não enviado</p>
                                                                )
                                                        }
                                                    </ListItemText>
                                                </ListItem>
                                            </Grid>
                                        </Grid>
                                        :
                                        <Grid container>
                                            <Grid item>
                                                <ListItem>
                                                    <ListItemIcon>
                                                        {paperURL ? (
                                                            <DoneIcon />
                                                        ) :
                                                            <ErrorIcon />
                                                        }
                                                    </ListItemIcon>
                                                    <ListItemText>
                                                        {
                                                            paperURL ?
                                                                (
                                                                    <a href={paperURL} target="_blank" rel="noopener noreferrer">Link para arquivo .docx</a>
                                                                ) :
                                                                (
                                                                    <p>Arquivo não enviado</p>
                                                                )
                                                        }
                                                    </ListItemText>
                                                </ListItem>
                                                <ListItem>
                                                    <ListItemIcon>
                                                        {paperURL2 ? (
                                                            <DoneIcon />
                                                        ) :
                                                            <ErrorIcon />
                                                        }
                                                    </ListItemIcon>
                                                    <ListItemText>
                                                        {
                                                            paperURL2 ?
                                                                (
                                                                    <a href={paperURL2} target="_blank" rel="noopener noreferrer">Link para arquivo .pdf</a>
                                                                ) :
                                                                (
                                                                    <p>Arquivo não enviado</p>
                                                                )
                                                        }
                                                    </ListItemText>
                                                </ListItem>
                                            </Grid>
                                        </Grid>
                                    :
                                    <Grid container>
                                        <Grid item>
                                            <ListItem>
                                                <ListItemIcon>
                                                    {paperFile ? (
                                                        <DoneIcon />
                                                    ) :
                                                        <ErrorIcon />
                                                    }
                                                </ListItemIcon>
                                                <ListItemText>
                                                    {paperFile ? (
                                                        <p>Arquivo DOCX carregado: {paperFile.name}</p>
                                                    ) :
                                                        (
                                                            <p>Arquivo não carregado</p>
                                                        )
                                                    }
                                                </ListItemText>
                                            </ListItem>
                                        </Grid>
                                        <Grid item>
                                            <ListItem>
                                                <ListItemIcon>
                                                    {paperFile2 ? (
                                                        <DoneIcon />
                                                    ) :
                                                        <ErrorIcon />
                                                    }
                                                </ListItemIcon>
                                                <ListItemText>
                                                    {paperFile2 ? (
                                                        <p>Arquivo PDF carregado: {paperFile2.name}</p>
                                                    ) :
                                                        (
                                                            <p>Arquivo não carregado</p>
                                                        )
                                                    }
                                                </ListItemText>
                                            </ListItem>
                                        </Grid>
                                    </Grid>
                            }
                            <br />
                        </List>
                    </div>
                </div>
            </Paper>
        </div>
    );
}

ThreeAsTwo.defaultProps = {
    readOnly: false
}

export default ThreeAsTwo;